"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("../../styles");
var global_styles_1 = require("../global.styles");
var muiPaper = __assign(__assign({}, global_styles_1.select.options.container), { '& li': __assign(__assign({}, global_styles_1.select.options.item.text), { '&[data-focus="true"], &[aria-selected="true"]': __assign({}, global_styles_1.select.options.item.selected), '&.multiple, &.multiple[data-focus="true"], &.multiple[aria-selected="true"]': __assign(__assign({ padding: 0 }, global_styles_1.select.options.item.multiple), { '& .MuiCheckbox-root': {
                padding: '4px 8px 4px 16px'
            }, '& .MuiCheckbox-colorSecondary.Mui-checked:hover': __assign({}, global_styles_1.select.options.item.multiple) }) }) });
exports.theme = styles_1.createMuiTheme({
    typography: {
        fontFamily: 'Montserrat'
    },
    props: {
        MuiButtonBase: {
            disableRipple: true
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [styles_2.paragraph]
            }
        },
        MuiIconButton: {
            root: {
                '&:hover': global_styles_1.icon.button,
                '& svg': global_styles_1.icon.svg
            }
        },
        MuiInput: {
            root: __assign(__assign(__assign({}, global_styles_1.input.size), global_styles_1.input.spacing), global_styles_1.input.text),
            underline: {
                '&:not(.Mui-disabled):before, &:hover:not(.Mui-disabled):before': global_styles_1.input.underline.default,
                '&:after': global_styles_1.input.underline.focused
            }
        },
        MuiTextField: {
            root: {
                '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
                    padding: 0
                }
            }
        },
        MuiInputLabel: {
            root: __assign(__assign({}, global_styles_1.input.text), global_styles_1.input.label)
        },
        MuiInputAdornment: {
            root: {
                '& .MuiTypography-root': __assign({}, global_styles_1.input.text)
            }
        },
        MuiFormLabel: {
            root: {
                '&.Mui-focused': __assign(__assign({}, global_styles_1.input.text), global_styles_1.input.label)
            }
        },
        MuiFormGroup: {
            root: {
                '& label:not(:last-of-type)': {
                    paddingBottom: 8
                }
            }
        },
        MuiPaper: {
            root: muiPaper,
            rounded: muiPaper,
            outlined: muiPaper
        },
        MuiCheckbox: {
            root: {
                padding: 0,
                '& span.unchecked': __assign(__assign({}, global_styles_1.checkbox.default), global_styles_1.checkbox.unchecked),
                '& span.checked': __assign(__assign({}, global_styles_1.checkbox.default), global_styles_1.checkbox.checked),
                '&:hover': {
                    cursor: 'pointer',
                    '& span.unchecked': __assign({}, global_styles_1.checkbox.focused)
                }
            },
            colorSecondary: {
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        MuiRadio: {
            root: {
                padding: 0
            },
            colorSecondary: {
                '&:hover': {
                    backgroundColor: 'transparent !important'
                }
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: 0,
                marginRight: 0,
                '&.Mui-disabled': {
                    cursor: 'not-allowed'
                }
            },
            label: {
                fontWeight: 500,
                paddingLeft: 8
            }
        },
        MuiChip: {
            root: __assign(__assign({}, global_styles_1.tag.root), { '& svg': global_styles_1.tag.svg }),
            label: __assign({}, global_styles_1.tag.label),
            deleteIcon: __assign({}, global_styles_1.tag.delete)
        }
    }
});
//# sourceMappingURL=material.theme.js.map